import React from "react";
import { Link } from "react-router-dom";
import { Truck, Sparkles, MapPin, ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden hero-gradient" data-testid="hero-section">
      {/* Decorative floating orbs */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-sky-400/20 rounded-full blur-3xl animate-float-soft" />
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-cyan-300/20 rounded-full blur-3xl animate-float-soft" style={{animationDelay: '1s'}} />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-16 md:py-24 lg:py-32 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="fade-up fade-up-1 inline-flex items-center gap-2 bg-white border border-sky-200 px-3 py-1.5 rounded-full text-xs font-bold text-sky-700 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-sky-500 animate-pulse" />
            Personalización en solo 15 minutos
          </div>

          <h1 className="fade-up fade-up-2 font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] text-black">
            Personaliza tu funda en{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-[#0EA5E9]">15 minutos</span>
              <span className="absolute inset-x-0 -bottom-2 h-3 bg-sky-200/70 -z-0 rounded-full" />
            </span>
          </h1>

          <p className="fade-up fade-up-3 mt-6 text-lg md:text-xl text-slate-600 max-w-xl leading-relaxed">
            Carcasas únicas con tus fotos, nombres o diseños. Calidad premium, listo en minutos y enviado a todo Chile 🇨🇱
          </p>

          <div className="fade-up fade-up-4 mt-8 flex flex-wrap gap-3">
            <Link to="/personalizar" data-testid="hero-customize-btn" className="btn-primary inline-flex items-center gap-2">
              Crear mi funda ahora
              <ArrowRight size={18} />
            </Link>
            <Link to="/accesorios" data-testid="hero-examples-btn" className="btn-outline-dark inline-flex items-center gap-2">
              Ver ejemplos
            </Link>
          </div>

          <div className="fade-up fade-up-4 mt-10 flex flex-wrap gap-3">
            <Badge icon={<Truck size={14} />} label="Entrega rápida" />
            <Badge icon={<Sparkles size={14} />} label="Diseño personalizado" />
            <Badge icon={<MapPin size={14} />} label="Envíos a todo Chile" />
          </div>
        </div>

        <div className="lg:col-span-5 relative" data-testid="hero-visual">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-slate-200 bg-white shadow-2xl tech-glow">
            <img
              alt="Funda personalizada Torvi con perro salchicha y gato American Shorthair"
              src="/generated/hero_pets_case.png"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 glass rounded-2xl p-4">
              <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Pedido #TOR-1241</div>
              <div className="font-heading font-bold text-black mt-0.5">Funda Personalizada · Mascotas</div>
              <div className="flex items-center gap-2 mt-2 text-xs">
                <span className="px-2 py-1 rounded-full bg-emerald-100 text-emerald-700 font-bold">Listo en 15 min</span>
                <span className="text-slate-500">· Diseño aprobado</span>
              </div>
            </div>
          </div>
          <div className="hidden md:block absolute -top-6 -right-6 bg-white rounded-2xl shadow-xl border border-slate-200 px-4 py-3 animate-float-soft">
            <div className="text-xs text-slate-500 font-bold uppercase">Garantía</div>
            <div className="font-heading font-black text-black">100% calidad</div>
          </div>
          <div className="hidden md:block absolute -bottom-6 -left-6 bg-[#0EA5E9] text-white rounded-2xl shadow-xl px-4 py-3 animate-float-soft" style={{animationDelay: '0.8s'}}>
            <div className="text-xs font-bold uppercase opacity-80">Compras +$20.000</div>
            <div className="font-heading font-black">🎁 Regalo sorpresa</div>
          </div>
        </div>
      </div>
    </section>
  );
}

const Badge = ({ icon, label }) => (
  <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-3.5 py-1.5 shadow-sm font-semibold text-sm text-slate-700">
    <span className="text-[#0EA5E9]">{icon}</span>
    {label}
  </div>
);
